/**
 * Represents a mark on the slider with a specific value and label.
 */
export interface SliderMark {
  /** The numeric value of the mark. */
  value: number;
  /** The text label to display at this mark's position. */
  label: string;
}
